export const adminRu = {
  admin: {
    dashboard: {
      title: 'Панель администратора',
      subtitle: 'Управление пользователями, контейнерами и предметами',
      users: {
        title: 'Пользователи',
        description: 'Управление учётными записями пользователей и правами доступа',
        button: 'Управление пользователями',
      },
      congregations: {
        title: 'Собрания',
        description: 'Управление собраниями и их участниками',
        button: 'Управление собраниями',
      },
    },
    users: {
      title: 'Управление пользователями',
      subtitle: 'Управление учётными записями пользователей и правами доступа',
      search: 'Поиск пользователей...',
      loadError: 'Не удалось загрузить пользователей',
      delete: 'Удалить',
      deleteConfirm: 'Вы уверены, что хотите удалить этого пользователя?',
      deleteSuccess: 'Пользователь успешно удалён',
      deleteError: 'Не удалось удалить пользователя',
      empty: 'Пользователи не найдены',
      emptyDescription: 'Ни один пользователь не соответствует критериям поиска.',
      admin: 'Администратор',
      user: 'Пользователь',
      active: 'Активен',
      inactive: 'Неактивен',
      verified: 'Подтверждён',
      unverified: 'Не подтверждён',
      makeUser: 'Сделать пользователем',
      makePremium: 'Сделать премиум пользователем',
      makeAdmin: 'Сделать администратором',
      roles: {
        user: 'Пользователь',
        admin: 'Администратор',
        premium: 'Премиум пользователь',
      },
      changeRole: {
        action: 'изменить роль на {role}',
        confirm: 'Вы уверены, что хотите {action}?',
        success: 'Роль пользователя изменена на {role}',
        error: 'Не удалось изменить роль пользователя',
      },
      toggleAdmin: {
        promote: 'Сделать администратором',
        demote: 'Убрать администратора',
        confirm: 'Вы уверены, что хотите {action}?',
        promoteSuccess: 'Пользователь повышен до администратора',
        demoteSuccess: 'Пользователь понижен с администратора',
        error: 'Не удалось обновить статус администратора пользователя',
      },
      columns: {
        name: 'Имя',
        email: 'Email',
        isAdmin: 'Админ',
        role: 'Роль',
        isActive: 'Активен',
        isEmailVerified: 'Подтверждён',
        createdAt: 'Создан',
        actions: 'Действия',
      },
    },
  },
}
